import { RouteInfo } from './sidebar.metadata';

/**
 * منوی استاندارد بر اساس تیم‌های کاری:
 * فروش و بازاریابی | فروش کالا و انبار | مدیریت پروژه | مالی پروژه
 * + مشترک: داشبورد، هوش مصنوعی، گزارش‌ها، خدمات، تعاریف، مدیریت سیستم
 */
export const ROUTES_ADMIN: RouteInfo[] = [
  {
    path: '',
    title: 'دشبورد',
    icon: 'mdi mdi-gauge',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/dashboard/dashboard', title: 'دشبورد مدیریت', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    ]
  },
  /*
  {
    path: '',
    title: 'بانک اطلاعاتی',
    icon: 'mdi mdi-database',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/page/customer-page', title: 'مشتریان', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/project-report', title: 'پروژه‌ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/salesCycles', title: 'فروش در دست', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/phone', title: 'مخاطبین', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      // { path: '/page/kalas', title: 'کالا ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      // { path: '/page/stocks', title: 'موجودی انبارها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      // { path: '/page/orders', title: 'کارتابل فروش کالا', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      // { path: '/page/suppliers', title: 'پیمانکاران', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      // { path: '/page/installers', title: 'نصاب‌ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      // { path: '/page/project-items', title: 'فازهای پروژه', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      // { path: '/page/factors/pre', title: 'پیش‌فاکتور پروژه', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      // { path: '/page/factors', title: 'فاکتور پروژه', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      // { path: '/page/incomings', title: 'دریافت و پرداخت', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    ]
  },
  */
  {
    path: '',
    title: 'فروش و بازاریابی',
    icon: 'mdi mdi-account-multiple',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/page/customer-page', title: 'مشتریان', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/group', title: 'گروه ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/campaign', title: 'ارسال پیام', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/phone', title: 'مخاطبین', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
//       { path: '/page/transaction', title: 'پیگیری های من', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
//       { path: '/page/review', title: 'نظرسنجی', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/transaction-report', title: 'لیست پیگیری‌ها و سرنخ‌ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/calendar-group', title: 'تقویم گروهی', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/salesCycles', title: 'فروش در دست', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/notes', title: 'یادداشت ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/files', title: 'فایل ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/file-shares-report', title: 'گزارش ارسال فایل به مشتری', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    {
      path: '/page/quote-design',
      title: 'طراحی پیش‌فاکتور',
      icon: 'mdi mdi-file-document-edit',
      class: '',
      label: '',
      labelClass: '',
      extralink: false,
      submenu: []
    },

    ]
  },
  {
    path: '',
    title: 'فروش محصولات و انبار',
    icon: 'mdi mdi-store',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/page/kalas', title: 'محصولات', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/orders', title: 'سفارش ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/orders-buy', title: 'خرید کالا', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/store', title: 'انبار', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/stocks', title: 'موجودی انبارها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
           { path: '/page/customer-advanced-search', title: 'جستجوی پیشرفته', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },

//       { path: '/page/rents', title: 'رنت ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    ]
  },
  {
    path: '',
    title: 'مدیریت پروژه',
    icon: 'mdi mdi-briefcase',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/page/project-report', title: 'پروژه‌ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/project-items', title: 'فازها و پیشرفت', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      // { path: '/page/project-task', title: 'وظایف', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/installers', title: 'نصاب‌ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/suppliers', title: 'پیمانکاران', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    ]
  },
  {
    path: '',
    title: 'مالی پروژه',
    icon: 'mdi mdi-calculator',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/page/factors/pre', title: 'پیش‌فاکتور پروژه', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/factors', title: 'فاکتور پروژه', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/factor-workflow-kartabl', title: 'کارتابل تأیید فاکتور پروژه', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/factor-workflows', title: 'همه فرایندهای فاکتور پروژه', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/incomings', title: 'دریافت و پرداخت', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/costs', title: 'هزینه‌ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    ]
  },
  {
    path: '',
    title: 'گزارش ها',
    icon: 'mdi mdi-chart-bar',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/dashboard/daily-report', title: 'گزارش دوره‌ای', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/bi-report', title: 'گزارش‌ساز', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/transaction-sales-cycle-report', title: 'گزارش قیف فروش', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/transaction-project-report', title: 'گزارش پروژه‌ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/report-staff', title: 'گزارش عملکرد نیروها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/factors-report', title: 'گزارش فروش کالا', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/dashboard/product-report', title: 'گزارش فروش محصولات', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/call-report', title: 'گزارش تماس ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    ]
  },
  {
    path: '',
    title: 'تعاریف پایه',
    icon: 'mdi mdi-settings',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/page/position', title: 'سمت ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/connector', title: 'معرف ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/phone-type', title: 'نوع تلفن ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/department', title: 'دفترهای کاری', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/action-type', title: 'نوع فعالیت ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/introduction', title: 'نحوه آشنایی', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/field-activity', title: 'زمینه های کاری', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/step', title: 'مراحل چرخه های فروش', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/project-step', title: 'تعریف فازهای پروژه', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/factor-workflow-steps', title: 'مراحل فرایند فاکتور پروژه', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    ]
  },
  {
      path: '',
      title: 'خدمات پس از فروش',
      icon: 'mdi mdi-headset',
      class: 'has-arrow',
      label: '',
      labelClass: 'label label-rouded label-themecolor pull-right',
      extralink: false,
      submenu: [
        { path: '/page/contracts', title: 'قرارداد ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
        { path: '/page/transaction-contract-report', title: 'آخرین فعالیت قراردادها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
        { path: '/page/tickets', title: 'تیکت ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      ]
    },

  {
      path: '',
      title: 'هوش مصنوعی',
      icon: 'mdi mdi-robot',
      class: 'has-arrow',
      label: '',
      labelClass: 'label label-rouded label-themecolor pull-right',
      extralink: false,
      submenu: [
        { path: '/page/smart-workspace', title: 'میزکار هوشمند', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
        { path: '/dashboard/manager-agent', title: 'گزارش هوشمند', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      ]
    },

  {
    path: '',
    title: 'مدیریت سیستم',
    icon: 'mdi mdi-security',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/admin/emplmng', title: 'مدیریت کاربران', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '', title: 'جعل کاربر', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/admin/client_mng', title: 'مدیریت کلاینت ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/admin/audit', title: 'وقایع ثبت شده', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/customer-archive-page', title: 'مشتریان آرشیو شده', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/customer-deleted-page', title: 'مشتریان حذف شده', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/project-report-delete', title: 'پروژه های حذف شده', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    ]
  },
];

export const ROUTES_USER: RouteInfo[] = [
  {
    path: '',
    title: 'دشبورد',
    icon: 'mdi mdi-gauge',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/dashboard/dashboard', title: 'دشبورد مدیریت', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    ]
  },
  /*
  {
    path: '',
    title: 'بانک اطلاعاتی',
    icon: 'mdi mdi-database',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/page/customer-page', title: 'مشتریان', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/project-report', title: 'پروژه‌ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/salesCycles', title: 'فروش در دست', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/phone', title: 'مخاطبین', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/kalas', title: 'کالا ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      // { path: '/page/stocks', title: 'موجودی انبارها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      // { path: '/page/orders', title: 'کارتابل فروش کالا', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      // { path: '/page/suppliers', title: 'پیمانکاران', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      // { path: '/page/installers', title: 'نصاب‌ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      // { path: '/page/project-items', title: 'فازهای پروژه', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      // { path: '/page/factors/pre', title: 'پیش‌فاکتور پروژه', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      // { path: '/page/factors', title: 'فاکتور پروژه', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      // { path: '/page/incomings', title: 'دریافت و پرداخت', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    ]
  },
  */
  {
    path: '',
    title: 'فروش و بازاریابی',
    icon: 'mdi mdi-account-multiple',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/page/customer-page', title: 'مشتریان', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/phone', title: 'مخاطبین', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/transaction', title: 'پیگیری های من', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/salesCycles', title: 'فروش در دست', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/transaction-report', title: 'لیست پیگیری‌ها و سرنخ‌ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/customer-advanced-search', title: 'جستجوی پیشرفته', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/notes', title: 'یادداشت ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/files', title: 'فایل ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/file-shares-report', title: 'گزارش ارسال فایل به مشتری', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/review', title: 'نظرسنجی', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/campaign', title: 'کمپین تبلیغاتی', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/group', title: 'گروه ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    ]
  },
  {
    path: '',
    title: 'فروش کالا و انبار',
    icon: 'mdi mdi-store',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/page/kalas', title: 'کالا ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/store', title: 'انبار', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/stocks', title: 'موجودی انبارها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/orders', title: 'کارتابل فروش کالا', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/orders-buy', title: 'خرید کالا (ورود انبار)', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/rents', title: 'رنت ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    ]
  },
  {
    path: '',
    title: 'مدیریت پروژه',
    icon: 'mdi mdi-briefcase',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/page/project-report', title: 'پروژه‌ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/project-items', title: 'فازها و پیشرفت', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/project-task', title: 'وظایف', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/suppliers', title: 'پیمانکاران', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/installers', title: 'نصاب‌ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    ]
  },
  {
    path: '',
    title: 'مالی پروژه',
    icon: 'mdi mdi-calculator',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/page/factors/pre', title: 'پیش‌فاکتور پروژه', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/factors', title: 'فاکتور پروژه', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/factor-workflow-kartabl', title: 'کارتابل تأیید فاکتور پروژه', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/factor-workflows', title: 'همه فرایندهای فاکتور پروژه', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/incomings', title: 'دریافت و پرداخت', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/costs', title: 'هزینه‌ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    ]
  },
//   {
//     path: '/page/quote-design',
//     title: 'طراحی پیش‌فاکتور',
//     icon: 'mdi mdi-file-document-edit',
//     class: '',
//     label: '',
//     labelClass: '',
//     extralink: false,
//     submenu: []
//   },
  {
    path: '',
    title: 'خدمات پس از فروش',
    icon: 'mdi mdi-headset',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/page/contracts', title: 'قرارداد ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/transaction-contract-report', title: 'آخرین فعالیت قراردادها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/tickets', title: 'تیکت ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    ]
  },
  {
    path: '',
    title: 'هوش مصنوعی',
    icon: 'mdi mdi-robot',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/page/smart-workspace', title: 'میزکار هوشمند', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/dashboard/manager-agent', title: 'گزارش هوشمند', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    ]
  },
  {
    path: '',
    title: 'گزارش ها',
    icon: 'mdi mdi-chart-bar',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/page/bi-report', title: 'گزارش‌ساز', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/transaction-sales-cycle-report', title: 'گزارش قیف فروش', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/transaction-project-report', title: 'گزارش پروژه‌ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/report-staff', title: 'گزارش عملکرد نیروها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    ]
  },
  {
    path: '',
    title: 'تعاریف پایه',
    icon: 'mdi mdi-settings',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/page/step', title: 'مراحل چرخه های فروش', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/action-type', title: 'نوع فعالیت ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/introduction', title: 'نحوه آشنایی', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/field-activity', title: 'زمینه های کاری', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/project-step', title: 'تعریف فازهای پروژه', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/factor-workflow-steps', title: 'مراحل فرایند فاکتور پروژه', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/department', title: 'دفترهای کاری', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/phone-type', title: 'نوع تلفن ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/position', title: 'سمت ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/connector', title: 'معرف ها', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    ]
  },
  {
    path: '',
    title: 'مدیریت سیستم',
    icon: 'mdi mdi-security',
    class: 'has-arrow',
    label: '',
    labelClass: 'label label-rouded label-themecolor pull-right',
    extralink: false,
    submenu: [
      { path: '/page/customer-archive-page', title: 'مشتریان آرشیو شده', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/customer-deleted-page', title: 'مشتریان حذف شده', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
      { path: '/page/project-report-delete', title: 'پروژه های حذف شده', icon: '', class: '', label: '', labelClass: '', extralink: false, submenu: [] },
    ]
  },
];

export const ROUTES_USER_LEVEL2: RouteInfo[] = [
  {
    path: '/page/transaction',
    title: 'پیگیری های من',
    icon: 'mdi mdi-gauge',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/page/calendar',
    title: 'تقویم کاری من',
    icon: 'mdi mdi-calendar-clock',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: []
  },
];

export const ROUTES_CLIENT: RouteInfo[] = [
  {
    path: '/page/tickets-client',
    title: 'تیکت ها',
    icon: 'mdi mdi-server-network',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: []
  }
];
